export default {"src":"/_next/static/media/icon-maintenance.f70d0ed6.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};